<template>
  <BaseAlert
    v-if="showAlert"
    color="text-secondary"
    :class="classNames"
    data-qa="review_card_alert"
  >
    <template v-if="rate.is_hidden_for_verification">
      {{ hiddenPrefix }}.
      {{ tStatic('Если вы автор, напишите нам') }}
      <a href="mailto:proverka@medrocket.ru">proverka@medrocket.ru</a>
      {{ tStatic('или позвоните') }}
      <a
        href="tel:+78006003028"
        class="text-no-wrap"
      >8 (800) 600-30-28</a>.
    </template>
    <template v-else-if="rate.is_deleted">
      {{ tStatic('Отзыв удалён автором') }}
      <template v-if="deletedDate">
        {{ deletedDate }}
      </template>
    </template>
    <template v-else-if="rate.is_refuted">
      <span v-html="refutationText/* eslint-disable-line vue/no-v-html */" />
    </template>
    <template v-else>
      {{ tStatic('Отзывы от неавторизованных пользователей не участвуют в рейтинге') }}
    </template>
  </BaseAlert>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import BaseAlert from 'www/vue_components/common/core/BaseAlert.vue'
import type { CommonContextStore } from 'src/types/context'
import useContextStore from 'src/store/useContextStore'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import type { Rate } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/types'
import { formatDeletedDate } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/functions/formatReviewDates'
import {
  getHiddenVerificationStatus,
  hasReviewAlert,
} from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/functions/getReviewAlertText'

const props = withDefaults(defineProps<{
  rate: Rate
  classNames?: string
}>(), {
  classNames: '',
})

const { context }: CommonContextStore = useContextStore()
const showAlert = computed(() => hasReviewAlert(props.rate))
const deletedDate = computed(() => formatDeletedDate(props.rate.dt_deleted_by_author))
const refutationText = computed(() => (
  props.rate.get_refutation_text
    ? tStatic(props.rate.get_refutation_text)
    : ''
))
const hiddenPrefix = computed(() => {
  const status = getHiddenVerificationStatus(props.rate)
  const brand = context.request.country.is_russia ? 'ПроДокторов' : 'YDoc'

  if (status === 'request_lpu') {
    return tStatic('Отзыв на расширенной проверке по запросу клиники')
  }

  if (status === 'request_doctor') {
    return tStatic('Отзыв на расширенной проверке по запросу врача')
  }

  if (status === 'request_adm') {
    return `${tStatic('Отзыв на расширенной проверке по решению')} ${brand}`
  }

  return tStatic('Отзыв на расширенной проверке')
})
</script>
